<template>
  <div class="startupload" v-show="seen">
    <div class="startupload-modal">
      <div v-if="!error && !error_size"
        style="display: flex;flex-direction: column;width: 70%;justify-content: center;align-items: center;">
        <strong>Uploading: </strong> {{ str_text(name) }}
        <div class="progress-bar">
          <span class="progress" :style="{ 'width': progress + '%' }">{{ progress }}%</span>
        </div>
      </div>
      <div v-if="error || error_size" class="error">
        <template v-if="error">
          <span>File of <strong>.{{ ext }}</strong> is not allowed</span>
          <span class="retry" @click="retry">Retry</span>
          <input type="file" class="pic" ref="pix" @change="start_upload" />
        </template>
        <template v-if="error_size">
          <span>File size should not be more than 1MB</span>
          <span class="retry" @click="retry">Retry</span>
          <input type="file" class="pic" ref="pix" @change="start_upload" />
        </template>
      </div>
    </div>
  </div>
</template>
<style scoped>
.startupload-modal {
  background-color: #fff;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  height: 200px;
  width: 420px;
  align-items: center;
  justify-content: center
}
</style>

<script>
import { setTimeout, clearInterval, setInterval } from 'timers'
import { connectedObservers, connectionObservers, uploadObservers } from '@/Observers.js'
import client from 'socket.io-file-stream/dist/web'
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      seen: false,
      progress: 0,
      name: '',
      error: false,
      ext: '',
      supportedFile: ['jpg', 'jpeg', 'png', 'gif'],
      error_size: false,
      show: true
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_SLIDEIN',
      'UPDATE_SLIDEOUT',
      'UPDATE_MENU',
      'UPDATE_BODY_MENU',
      'SET_PHOTO',
      'SET_COMPANY_PHOTO'
    ]),
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 12, 12)
        return fSeg + '....' + sSeg
      }
      return str
    },
    logincall() {
      this.$parent.logincall()
    },
    retry() {
      this.seen = false
      this.$refs.pix.click()
    },
    containStr(a, str) {
      for (var i = 0; i < a.length; i++) {
        if (a[i].search(str) > -1) {
          return 1
        }
      }
      return 0
    },
    checkfile(file) {
      let name = file.split('.')
      let ext = name[name.length - 1]
      this.ext = ext
      if (this.containStr(this.supportedFile, ext) < 1) {
        this.error = true
      }
    },
    start_upload() {
      this.load(this.$refs.pix.files[0])
      this.$refs.pix.value = ''
    },
    load(file, show = true) {
      this.seen = true
      this.error = false
      this.error_size = false
      this.progress = 0
      this.show = show
      this.checkfile(file.name)
      let name = file.name.split('.')
      delete name[name.length - 1]
      this.name = name.join('')
      let that = this
      let data = {
        name: file.name,
        size: file.size,
        token: cookies.getCookie('token')
      }
      const conn = connectionObservers.subscribe((action) => {
        if (action === 'disconnected') {
          // console.log(c.id)
          // console.log(that.files[id].done)
          // that.files[id].network = true
        }
      })
      const c = new client(this.$socket, { file, data })
      c.upload('upload-company-profile-pic', (data) => {
        if (data.data === true) {
          console.log(data.photo)
          // that.SET_PHOTO(data.photo)
          that.SET_COMPANY_PHOTO(data.photo)
          that.seen = false

        }
        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
      c.on('progress', (data) => {
        that.progress = Math.floor((data.total / data.size) * 100)
      })
    }
  }
}
</script>